import appActions from './appAction';
import i18n from '../i18next';

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');
var MiscueSessionApi = require('../api/miscueSessionApi');
var utils = require('../utils');

var MiscueSessionPagingObject = function () {

  utils.AbstractPagingObject.apply(this, arguments);

};

var MiscueSessionAction = {

  createPagingObject(){
    return new MiscueSessionPagingObject();
  },

  createLastSessionsPagingObject(){
    var paging = new MiscueSessionPagingObject();
    paging.itemsPerPage(5);
    return paging;
  },

  getLatestMiscueSessions(pageObject){
    MiscueSessionApi.getRecentMiscueSessions(pageObject.toDataObject(), null).then(function (miscueSessions) {
      Dispatcher.dispatch({
        actionType: ActionType.MISCUE_SESSIONS_GET_LATEST,
        miscueSessions: miscueSessions.list
      })
    });
  },

  getRecentMiscueSessions(pageObject, learnerId){
    if (!pageObject instanceof MiscueSessionPagingObject) {
      throw Error('pageObject must be instance of MiscueSessionPagingObject');
    }

    MiscueSessionApi.getRecentMiscueSessions(pageObject.toDataObject(), learnerId).then(function (miscueSessions) {
      pageObject.lastPagingResponse(miscueSessions.paging);
      Dispatcher.dispatch({
        actionType: ActionType.MISCUE_SESSIONS_GET_RECENT,
        miscueSessions: miscueSessions.list,
        learnerId: learnerId || null,
        appendRecords: !pageObject.isNewSearch
      })
    });
  },

  getMiscueSessionDetails(assessmentId){
    if (!assessmentId) return;
    MiscueSessionApi.getMiscueSessionDetails(assessmentId).then(function (assessmentDetails) {
      Dispatcher.dispatch({
        actionType: ActionType.MISCUE_SESSIONS_GET_ASSESSMENT_DETAILS,
        assessmentId: assessmentId,
        assessmentDetails: assessmentDetails
      })
    });
  },

  async saveMiscueSessionNote(assessmentId, noteText){
    try {
      await MiscueSessionApi.saveMiscueSessionNote(assessmentId, noteText);
      Dispatcher.dispatch({
        actionType: ActionType.MISCUE_SESSIONS_PATCH_ASSESSMENT_NOTE_SUCCESS,
        assessmentId: assessmentId,
        noteText: noteText
      });
      appActions.notifySuccess(i18n.t('Notes updated'), i18n.t('Assessment Session'));
    } catch (error) {
      Dispatcher.dispatch({ actionType: ActionType.MISCUE_SESSIONS_PATCH_ASSESSMENT_NOTE_ERROR });
      appActions.notifyError(null, i18n.t('Observation Detail'));
    }
  },
  
  async getMiscueYearGroups() {
    const yearGroups = await MiscueSessionApi.getMiscueYearGroups();
    Dispatcher.dispatch({
      actionType: ActionType.MISCUE_SESSIONS_GET_MISCUE_YEAR_GROUPS,
      miscueYearGroups: yearGroups
    });
    return yearGroups;
  },

  deleteMiscueSession(idsList) {
    return MiscueSessionApi.deleteMiscueSession(idsList)
      .then(() => {
        Dispatcher.dispatch({
          actionType: ActionType.MISCUE_SESSIONS_DELETE,
          assessmentId: idsList
        })
      });
  },

  saveMiscueItem(assessmentId, itemData){
    var {id, text} = itemData;

    if (!id) {
      throw Error("Can't find misscue item id");
    }

    MiscueSessionApi.saveMiscueItem(id, text).then(function () {
      Dispatcher.dispatch({
        actionType: ActionType.MISCUE_SESSIONS_PATCH_MISCUE,
        assessmentId: assessmentId,
        miscueItem: itemData
      })
    });
  },

  deleteMiscueItem(assessmentId, miscueId){
    MiscueSessionApi.deleteMiscueItem(miscueId).then(function () {
      Dispatcher.dispatch({
        actionType: ActionType.MISCUE_SESSIONS_DELETE_MISCUE,
        assessmentId: assessmentId,
        miscueItemId: miscueId
      })
    });
  }


};

module.exports = MiscueSessionAction;
